import { RouteConfig } from "@/routes/types/route.types.ts";
import { PublicOfferView } from "@/pages/recruit/offers/PublicOfferView.tsx";

export const offersRoutes: RouteConfig[] = [
  {
    path: "/offers/public/:uuid/:offerId",
    element: <PublicOfferView />,
  },
];
